export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 text-background-50 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="fa-solid fa-cat text-lg"></i>
              </span>
              <span className="text-lg font-heading font-bold">皮皮喵漫画</span>
            </a>
            <p className="text-sm text-foreground-200 leading-relaxed mb-4">
              专注韩漫、日漫、国漫的免费在线阅读平台。海量热门漫画资源，每日同步更新，分类齐全，追更无忧。
            </p>
            <div className="flex items-center gap-3">
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#footer" onClick={(e) => e.preventDefault()} className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#index" onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">主题索引</a>
              <a href="#topics" onClick={(e) => { e.preventDefault(); document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">话题广场</a>
              <a href="#carousel" onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#ranking" onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">热门排行</a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#index" onClick={(e) => e.preventDefault()} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">韩漫专区</a>
              <a href="#index" onClick={(e) => e.preventDefault()} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">日漫经典</a>
              <a href="#index" onClick={(e) => e.preventDefault()} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">国漫精选</a>
              <a href="#cards" onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">精选合集</a>
              <a href="#updates" onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">最新动态</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400">诚邀优质内容方与平台合作，共同打造更好的漫画阅读生态。</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">&copy; 2024 皮皮喵漫画 - 韩漫日漫国漫系列漫画大全。本站所有内容仅供学习交流，版权归原作者所有。</p>
          <p className="text-xs text-foreground-500">用心做好漫画阅读体验</p>
        </div>
      </div>
    </footer>
  );
}